import { Link } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';

const faqs = [
  {
    q: 'Hitorigoto とはどんなサービスですか？',
    a: '音声で日記を録音すると、AIが自動で文字起こし・整形・タグ付けしてくれる日記アプリです。手書きやタイピングが面倒な方でも、話すだけで日記を残せます。',
  },
  {
    q: '無料プランとプレミアムプランの違いは？',
    a: '無料プランでは月間の録音時間とAI振り返り回数に制限があります。プレミアムプランでは録音時間の拡大、ワードクラウド、詳細な振り返り分析などが利用できます。',
  },
  {
    q: 'プレミアムプランの解約方法は？',
    a: '設定ページの「プラン管理」からいつでも解約できます。解約後も現在の請求期間の終了まで引き続きプレミアム機能をご利用いただけます。',
  },
  {
    q: '日記データのプライバシーは保護されていますか？',
    a: 'はい。日記データは暗号化されて保存され、他のユーザーからアクセスすることはできません。詳しくはプライバシーポリシーをご覧ください。',
  },
  {
    q: '対応ブラウザは？',
    a: '最新版の Google Chrome、Safari、Firefox、Microsoft Edge に対応しています。スマートフォンのブラウザからもご利用いただけます。',
  },
  {
    q: '録音した音声はどうなりますか？',
    a: '音声はサーバーで文字起こし処理後に自動削除されます。音声データ自体は保存されません。',
  },
  {
    q: 'アカウントを削除したい場合は？',
    a: '下記のお問い合わせ先メールアドレスまでご連絡ください。アカウントと関連する全てのデータを削除いたします。',
  },
];

export default function SupportPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" size="sm" className="mb-6 gap-1.5">
            <ArrowLeft className="h-4 w-4" />
            トップへ戻る
          </Button>
        </Link>

        <h1 className="text-lg font-bold mb-6">サポート</h1>

        {/* FAQ */}
        <section className="mb-8">
          <h2 className="text-sm font-semibold mb-4">よくある質問</h2>
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <details key={i} className="group rounded-lg border px-4 py-3">
                <summary className="text-sm font-medium cursor-pointer list-none flex items-center justify-between">
                  {faq.q}
                  <span className="text-muted-foreground transition-transform group-open:rotate-180">
                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </summary>
                <p className="text-xs text-muted-foreground mt-2 leading-relaxed">{faq.a}</p>
              </details>
            ))}
          </div>
        </section>

        {/* Contact */}
        <section className="rounded-lg border p-5 text-center space-y-3">
          <h2 className="text-sm font-semibold">お問い合わせ</h2>
          <p className="text-xs text-muted-foreground">
            上記で解決しない場合は、メールでお気軽にご連絡ください。
          </p>
          <a href="mailto:support@hitorigoto.app">
            <Button variant="outline" className="gap-2">
              <Mail className="h-4 w-4" />
              support@hitorigoto.app
            </Button>
          </a>
          <p className="text-xs text-muted-foreground">
            通常2営業日以内にご返信いたします。
          </p>
        </section>
      </div>
    </div>
  );
}
